import { PeekGrid, PeekPaper, PeekStack, PeekTimePicker, PeekTypography, useTheme, } from "@piiqtechnologies/ui-components";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
var TIME_VALUES;
(function (TIME_VALUES) {
    TIME_VALUES["START"] = "startTime";
    TIME_VALUES["END"] = "endTime";
})(TIME_VALUES || (TIME_VALUES = {}));
export const TimeWindowSelector = ({ label, form, disabled = false }) => {
    const theme = useTheme();
    const [errorDate, setErrorDate] = useState(undefined);
    const errorMessage = (error) => {
        const intl = useIntl();
        switch (error.message) {
            case "maxTime":
            case "minTime": {
                return intl.formatMessage(messages.dateRangeError);
            }
            case "invalidDate": {
                return intl.formatMessage(messages.invalidTimeError, { value: error === null || error === void 0 ? void 0 : error.value });
            }
            default: {
                return "";
            }
        }
    };
    const handleUpdateTime = (value, time) => {
        if (value === "startTime") {
            form.setFieldValue("scannerArrivalWindow.from", time);
            return;
        }
        form.setFieldValue("scannerArrivalWindow.to", time);
    };
    return (React.createElement(PeekGrid, { item: true, xs: 12 },
        React.createElement(PeekStack, { spacing: theme.spacing(0.6) },
            React.createElement(PeekStack, { spacing: 0.2, direction: "row" },
                React.createElement(PeekTypography, { variant: "h4", color: !disabled ? "inherit" : theme.palette.grey[300] }, label),
                React.createElement(PeekTypography, { variant: "h4", color: "error" }, "*")),
            React.createElement(PeekPaper, { variant: "outlined", sx: {
                    px: theme.spacing(0.8),
                    py: theme.spacing(0.5),
                    background: !disabled ? "initial" : theme.palette.grey[50],
                    border: `${theme.spacing(0.05)} solid ${(errorDate === null || errorDate === void 0 ? void 0 : errorDate.message) ? theme.palette.error.main : theme.palette.grey[100]}`,
                } },
                React.createElement(PeekStack, { direction: "row", gap: 0.25, my: 0.5, alignItems: "center" },
                    React.createElement(PeekTimePicker, { disableOpenPicker: true, value: form.values.scannerArrivalWindow.from, maxTime: form.values.scannerArrivalWindow.to, onChange: (time) => {
                            handleUpdateTime(TIME_VALUES.START, time);
                        }, disabled: disabled || (errorDate === null || errorDate === void 0 ? void 0 : errorDate.value) === TIME_VALUES.END, onError: (reason) => {
                            if (reason) {
                                setErrorDate({ message: reason, value: TIME_VALUES.START });
                                return;
                            }
                            setErrorDate(undefined);
                        } }),
                    React.createElement(PeekTypography, null, "\u2014"),
                    React.createElement(PeekTimePicker, { disableOpenPicker: true, value: form.values.scannerArrivalWindow.to, minTime: form.values.scannerArrivalWindow.from, onChange: (time) => {
                            handleUpdateTime(TIME_VALUES.END, time);
                        }, disabled: disabled || (errorDate === null || errorDate === void 0 ? void 0 : errorDate.value) === TIME_VALUES.START, onError: (reason) => {
                            if (reason) {
                                setErrorDate({ message: reason, value: TIME_VALUES.END });
                                return;
                            }
                            setErrorDate(undefined);
                        } })))),
        !!(errorDate === null || errorDate === void 0 ? void 0 : errorDate.message) && (React.createElement(PeekStack, { paddingTop: theme.spacing(0.5) },
            React.createElement(PeekTypography, { color: "error" }, errorMessage(errorDate))))));
};
export default TimeWindowSelector;
